<template>
  <v-app>
    <v-row no-gutters justify="center" align="center" class="my-10" v-if="!areInitialDatasFetched">
      <v-progress-circular indeterminate color="primary darken-1"></v-progress-circular>
    </v-row>
    <template v-else-if="areInitialDatasFetched && isDeviceSizeOk">
      <init-account-layout v-if="layout === `initaccount`" />
      <auth-layout v-else-if="layout === `auth`" />
      <indeego-settings-layout v-else-if="layout === `indeegosettings`" />
      <template v-else-if="layout === `none`">
        <router-view></router-view>
      </template>
      <app-layout v-else />
    </template>
    <not-for-mobile v-else-if="!isDeviceSizeOk" />
  </v-app>
</template>

<script>
import _ from 'lodash';
import InitAccountLayout from '@/layouts/InitAccount.vue';
import AuthLayout from '@/layouts/Auth.vue';
import IndeegoSettingsLayout from '@/layouts/IndeegoSettings.vue';
import AppLayout from '@/layouts/App.vue';
import NotForMobile from '@/views/NotForMobile.vue';
import { mapGetters, mapMutations, mapState } from 'vuex';

export default {
  name: `App`,

  data: () => ({
  }),

  computed: {
    ...mapState(`ui/mainLayout`, [
      `forceDeviceTooSmall`,
    ]),
    ...mapState(`ui/mainLayout`, {
      storeAreInitialDatasFetched: `areInitialDatasFetched`,
    }),
    ...mapGetters(`ui/mainLayout`, [
      `isGlobalApp`,
    ]),
    // ...mapState(`model/auth`, {
    //   storeIsUnifiedUser: `isUnifiedUser`,
    // }),
    areInitialDatasFetched: {
      get() { return this.storeAreInitialDatasFetched; },
      set(value) { this.SET_ARE_INITIAL_DATAS_FETCHED(value); },
    },
    // isUnifiedUser: {
    //   get() { return this.storeIsUnifiedUser; },
    //   set(value) { this.SET_IS_UNIFIED_USER(value); },
    // },
    layout() {
      const routeMeta = this.$route.meta || {};
      const layout = routeMeta.layout || `App`;

      return _.toLower(layout);
    },
    isTooSmallDevice() {
      return this.$vuetify.breakpoint.width < 930;
    },
    isDeviceSizeOk() {
      return !this.isTooSmallDevice || this.forceDeviceTooSmall;
    },
    isAuthorizedRouterOnGlobalApp() {
      return [`login`, `sso`, `logout`].includes(this.$route.name);
    },
  },

  methods: {
    refreshPlatformState() { return this.$store.dispatch(`platform/refresh`); },
    ...mapMutations(`ui/mainLayout`, [
      `SET_ARE_INITIAL_DATAS_FETCHED`,
    ]),
    ...mapMutations(`model/auth`, [
      `SET_IS_UNIFIED_USER`,
    ]),
    goToLogin() {
      if (this.$route.name !== `login`) {
        this.$router.replace({ name: `login` });
      }
    },
  },

  mounted() {
    this.refreshPlatformState();
    window.addEventListener(`focus`, this.refreshPlatformState);
    this.platformTimer = setInterval(this.refreshPlatformState, 60000);
  },
  beforeDestroy() {
    clearInterval(this.platformTimer);
    window.removeEventListener(`focus`, this.refreshPlatformState);
  },
  async beforeMount() {
    this.areInitialDatasFetched = false;
    if (this.$route.name !== `logout`) {
      try {
        await Promise.all([
          this.$store.dispatch(`model/user/fetchMe`),
          this.$store.dispatch(`model/client/fetchCompany`),
        ]);
      } catch (e) {} // eslint-disable-line
    }
    if (this.isGlobalApp && !this.isAuthorizedRouterOnGlobalApp) {
      this.goToLogin();
    } else if (this.$route.query?.unified === `1`) {
      this.SET_IS_UNIFIED_USER(true);
    }

    this.$store.dispatch(`model/user/logVisit`);
    this.areInitialDatasFetched = true;
    setTimeout(() => {
      this.isUnifiedUserDialogOpened = true;
    }, 1000);
  },

  watch: {
    $route() {
      this.refreshPlatformState();
      if (this.isGlobalApp && !this.isAuthorizedRouterOnGlobalApp) {
        this.goToLogin();
      }
    },
  },

  components: {
    InitAccountLayout,
    AuthLayout,
    IndeegoSettingsLayout,
    AppLayout,
    NotForMobile,
  },
};
</script>

<style lang="scss">
  * {
    z-index: 10;
  }

  .theme--light.v-application {
    background-color: #FFF !important;
    // background-color: #E7EBF2 !important;
  }

  @media only screen and (min-width: 1264px) {
    .container:not(.container--fluid) {
      max-width: 980px !important;
    }
  }
  .user_tools_legacy {
    font-size: 11px;
    color: #999;
    padding-top: 8px;
    padding-bottom: 8px;

    a {
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }

    .separator {
      text-align: center;
      width: 12px;
    }
  }

  .quick-access-ticket {
    input {
      line-height: 32px;
      width: 170px;
      padding: 1px 5px;
      height: initial;
      border: 1px solid #a4a4a4;
      margin-right: 6px;
    }
  }

  .nav-bar {
    .v-toolbar__content {
      padding-top: 0px;
      padding-bottom: 0px;
    }

    .nav-btn.v-btn--active::before {
      background-color: transparent !important;
    }
  }

  .side-content,
  .side-content-small,
  .side-content-medium {
    position: relative;
  }

  .side-content {
    width: $sideContentWidth;
  }

  .side-content-small {
    width: $sideContentSmallWidth;
  }

  .side-content-medium {
    width: $sideContentMediumMinWidth;
  }

  @media only screen and (min-width: 1100px) {
    .side-content-medium {
      width: $sideContentMediumMaxWidth;
    }
  }

  .content-header {
    height: 65px;
  }

  .page-main-content {
    & > .v-data-table {
      border: 1px solid #DDDDDD;
      border-radius: $contentCardRadius;
    }
  }

  .input-no-b-line {
    &.v-text-field > .v-input__control > .v-input__slot:after {
      display: none;
    }
  }

  .n-container {
    width: 100%;
    max-width: 1920px;
    position: relative;
  }

  .n-container-medium {
    width: 100%;
    max-width: 1280px;
  }

  .n-container-small {
    width: 100%;
    max-width: 980px;
  }

  .n-btn,
  .n-text-btn,
  .n-white-btn,
  .n-primary-btn,
  .n-secondary-btn {
    letter-spacing: 0rem !important;
    // letter-spacing: 0.035rem !important;
    text-transform: none !important;
  }

  // .n-btn,
  // .n-primary-btn,
  // .n-secondary-btn {
  //   box-shadow: none !important;
  // }

  .n-small-btn {
    min-width: 40px !important;
    height: 32px !important;
  }

  .n-text-btn {
    height: auto !important;
    width: auto !important;
    color: $primaryColor !important;
    text-decoration: underline;
    background-color: transparent !important;
    padding: 0px !important;
    border: 0px !important;
    -webkit-box-shadow: none;
    -moz-box-shadow:    none;
    box-shadow:         none;
    &::before {
      display: none !important;
    }
    &:hover {
      text-decoration: none;
    }
  }

  .n-white-btn {
    background-color: #FFF !important;
    color: #131a9a !important;
    border: 1px solid rgba(19, 26, 154, 0.1) !important;
    -webkit-box-shadow: 3px 3px 10px 1px rgba(19, 26, 154, 0.1);
    -moz-box-shadow:    3px 3px 10px 1px rgba(19, 26, 154, 0.1);
    box-shadow:         3px 3px 10px 1px rgba(19, 26, 154, 0.1);
    &::before {
      left: -1px;
      right: -1px;
    }
  }

  .n-secondary-btn:not(.v-btn--disabled) {
    background-color: #FFD641 !important;
    color: #13169a !important;
    border: 1px solid #cfae35 !important;
  }

  .n-primary-btn {
    background-color: #131a9a !important;
    color: #FFF !important;
    border: 1px solid #361ba1 !important;
    border-radius: 6px !important;
    -webkit-box-shadow: 3px 3px 10px 1px rgba(19, 26, 154, 0.1);
    -moz-box-shadow:    3px 3px 10px 1px rgba(19, 26, 154, 0.1);
    box-shadow:         3px 3px 10px 1px rgba(19, 26, 154, 0.1);

    &:hover {
      background-color: rgb(19, 26, 154, 0.8) !important;
      border-color: rgb(19, 26, 154, 0.2) !important;
    }
  }

  .n-icon-btn {
    height: 32px !important;
    width: 32px !important;
    min-width: 28px !important;
    border: 1px solid rgba(19, 26, 154, 0.1) !important;
    padding: 0 !important;
    border-radius: 6px !important;

    &.theme--light.v-btn.v-btn--disabled.theme--light:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
      background-color: #FFF !important;
      // background-color: rgba(19, 26, 154, 0.01) !important;
      border: 1px solid rgba(19, 26, 154, 0.05) !important;
      .v-icon {
        color: rgba(19, 26, 154, 0.25) !important;
      }
      // background-color: rgba(19, 26, 154, 0.1) !important;
      // border: 1px solid rgba(19, 26, 154, 0.05) !important;
    }
    // padding: 0 8px !important;
  }
  .n-large-btn {
    height: 56px !important;
  }

  .n-select,
  .n-multi-select {
    background-color: #FFF;
    &:not(.input-no-b-line) {
      border: 1px solid #AAA;
      border-radius: 6px;
    }
    &.n-select {
      max-height: 36px;
    }
    & > .v-input__control {
      min-height: 30px !important;
      & > .v-input__slot {
        min-height: 36px;
        background-color: transparent !important;
      }
    }
  }

  .n-text-field {
    background-color: #FFF;
    border-radius: 6px;
    max-height: 36px;
    & > .v-input__control {
      min-height: 30px !important;
      & > .v-input__slot {
        background-color: transparent !important;
        min-height: initial !important;
      }
    }
  }

  .ellipsis {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .app-footer {
    height: 40px;
    background-color: #101010;
    text-align: center;
    color: #FFF;
    font-size: 0.8rem;
    line-height: 40px;
    margin-top: 30px;
    padding: 0px;
  }

  .relative {
    position: relative;
  }

  .absolute-progress {
    position: absolute;
    top: 0px;
    left: 0px;
    right: 0px;
  }

  .dialog-fullscreen-floating {
    min-width: 95vw;
    min-height: 95vh;
    max-width: 95vw;
    max-height: 95vh;
  }

</style>
